import { useQueryClient } from '@tanstack/react-query';
import { LOAD_QUERY_KEYS } from './keys';
import { type AcquisitionType } from '../../../support/acquisitionTypes';

interface OnLoadConfigData {
  hasRfSubscription: boolean;
  batchAgreements: unknown[] | null;
}

// Reads the per-acquisition-type slice of the load payload owned by useOnLoad.
// Lives here so LOAD_QUERY_KEYS stays internal to api/load (ADR-014); the load
// key carries assetType/genId the banner can't reconstruct, so this matches on
// the partial root key rather than suspending on an exact key.
const useOnLoadConfigData = (
  acquisitionType: AcquisitionType | null
): OnLoadConfigData => {
  const queryClient = useQueryClient();

  const [[, onLoadData] = []] = queryClient.getQueriesData<{
    configs?: Record<
      string,
      { hasRfSubscription?: boolean; batchAgreements?: unknown[] }
    >;
  }>({ queryKey: LOAD_QUERY_KEYS.root() });

  const configForType = onLoadData?.configs?.[acquisitionType ?? ''];

  return {
    hasRfSubscription: Boolean(configForType?.hasRfSubscription),
    batchAgreements: configForType?.batchAgreements ?? null,
  };
};

export default useOnLoadConfigData;
